<template>
  <transition name="fade">
    <div v-if="error" class="bg-error">{{ error }}</div>
  </transition>
</template>

<style scoped>
@import "./style.css";
</style>

<script>
export default {
  name: "BgError",
  props: {
    error: String,
  },
};
</script>
